const queryKeys = {
  users: { activatedUsers: 'activated-users', deactivatedUsers: 'deactivated-users' },
  user: {
    notificationPreferences: 'user-notification-preferences',
  },
  assessment: {
    allAssessments: 'all-assessments',
    screenersByUserId: 'screeners-by-user-id',
    screenerById: 'screener-by-id',
  },
  organization: {
    allOrganizations: 'all-organizations',
    memberCareSpecialists: 'org-member-care-specialists',
    organizationRoster: 'organization-roster',
    organizationContracts: 'organization-contracts',
    organizationActiveContract: 'organization-active-contracts',
  },
  organizationLeads: { allLeads: 'all-organization-leads', deleteLead: 'delete-organization-lead' },
  legalDocument: { allLegalDocuments: 'all-legal-documents' },
  memberCare: {
    memberCareSpecialistOwnProfile: 'member-care-own-profile',
    memberCareSpecialists: 'member-care-specialists',
    memberCareSpecialistById: 'member-care-specialist-by-id',
    memberCaresMemberById: 'member-cares-member-by-id',
    memberCaresMemberTimeline: 'member-cares-member-timeline',
    memberCaresMemberObservations: 'member-cares-member-observations',
    memberCaresMemberNotes: 'member-cares-member-notes',
    assignedOrgs: 'member-care-assigned-orgs',
    unassignedOrgs: 'member-care-unassigned-orgs',
    memberCareMembers: 'member-care-members',
    memberCareOrganizations: 'member-care-orgs',
    memberCareOrganizationDashboard: 'member-care-org-dashboard',
    memberCareOrganizationRoster: 'member-care-org-roster',
    inviteToPlatform: 'member-care-invite-to-platform',
  },
  contracts: {
    all: 'all-contracts',
    documents: 'contract-documents',
  },
  providers: {
    all: 'all-providers',
    byId: 'provider-by-id',
    byActivity: 'provider-by-activity',
  },
  creatorApplications: {
    all: 'all-creator-applications',
    byId: 'creator-application-by-id',
  },
  content: {
    all: 'all-content',
    byId: 'content-by-id',
    auditLog: 'content-audit-log',
  },
  notifications: {
    latest: 'notifications-latest',
    unreadCount: 'notifications-unread-count',
    infinite: 'notifications-infinite',
    toggleReadMultiple: 'notifications-toggle-read-multiple',
    toggleReadSingle: 'notifications-toggle-read-single',
    allNotifications: 'all-notifications-superadmin',
  },
  meta: {
    USStates: 'meta-us-states',
  },
  superAdmin: {
    searchOrganizations: 'super-admin-search-organizations',
    currentOrganizationContext: 'super-admin-current-organization-context',
  },
  featureFlags: {
    admin: 'admin-feature-flags',
  },
  metrics: 'metrics',
};

export default queryKeys;
